<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
    style="padding: 0"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast
        [(message)]="error"
        [duration]="10000"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form">
      <div class="section">
        <h2
          style="
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #3f4395;
          "
        >
          Select Entity Type
        </h2>
        <div class="grouped fields">
          <div class="field" appMargin marginT="5">
            <sui-radio-button name="entity" value="company" [(ngModel)]="eRadio"
              ><strong
                style="
                  font-family: Roboto;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 18.75px;
                  text-align: left;
                "
                >Company Entity
              </strong>
            </sui-radio-button>
          </div>
          <div class="field" appMargin marginT="5">
            <div>
              <sui-radio-button name="entity" value="mda" [(ngModel)]="eRadio"
                ><strong
                  style="
                    font-family: Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 18.75px;
                    text-align: left;
                  "
                  >MDA Entity</strong
                >
              </sui-radio-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    (click)="submit()"
    autofocus
  >
    Continue
  </button>
</div>
